<template>
  <div class="flex gap-2 w-full h-full" :class="isPopup ? 'flex-col sm:flex-row' : ''">
    <div class="grow bg-white rounded-lg">
      <p class="text-blue font-display font-bold cursor-auto"
        :class="isPopup ? 'text-[2.75rem] leading-[47px] mb-5' : 'text-[1.75rem] leading-8 '">
        <span v-html="$t('trading_central_package')"></span>
      </p>
      <div v-if="TotalDeposited === 0 || isPopup">
        <p class="text-gray-900 font-normal"
          :class="isPopup ? 'text-[16px] mb-[40px]' : 'text-xs mt-2 mb-[40px] md:mb-[22px]'">
          {{ isPopup ? $t('trading_central_popup_text') : $t('trading_central_trading_tools') }}
        </p>
        <div class="cursor-pointer" :class="isPopup
          ? 'block w-28 text-center bg-green text-white px-5 py-[14px] rounded-md'
          : 'w-28 py-0.5 mb-2 table text-green rounded-xl bg-white hover:bg-[#20B38126] border border-green border-solid text-center text-sm font-medium'
          " @click="goToFinance">
          {{ $t('deposit').tTitle() }}
        </div>
        <div class="relative sm:overflow-visible mt-3" :class="isPopup ? 'h-[60px]' : 'h-[50px]'">
          <p class="sm:absolute sm:w-[121%] top-0 text-gray-600 z-10" :class="isPopup ? 'text-[12px]' : 'rtl:sm:w-full text-[10px]'"
            v-html="$t('trading_central_min_deposit', { value: $formatMoney(tradingCentralMax, currencySymbols[User.wallet.currency]), URL: `${tradingCentralURL}`, date: depositsAfterDate })">
          </p>
        </div>
      </div>
      <div v-else-if="TotalDeposited > 0 && TotalDeposited < tradingCentralMax">
        <a v-if="tradingCentralProgressPercentage !== 100" target="_blank" :href="`${tradingCentralURL}`"
          class="mt-4 mb-[30px] w-28 py-0.5 table text-blue rounded-xl bg-white hover:bg-[#2B63E326] border border-blue border-solid text-center text-sm font-medium">{{
            $t('learn_more').tTitle() }}
        </a>
        <p class="text-[10px] mb-1">{{ $t('trading_central_progress_towards') }} {{ $formatMoney(tradingCentralMax,
          currencySymbols[User.wallet.currency]) }}</p>
        <div class="h-3 w-4/5 bg-blue rounded-xl bg-opacity-25 relative">
          <div class="absolute inset-0 rounded-xl text-white text-center font-medium text-[10px] leading-none"
            :class="tradingCentralProgressPercentage === 100 ? 'bg-green' : 'bg-blue'"
            :style="'width: ' + Math.floor(tradingCentralProgressPercentage) + '%;'"></div>
        </div>
        <div class="flex justify-between w-4/5 h-full">
          <p class="text-[10px]">{{ $formatMoney(Math.min(TotalDeposited, tradingCentralMax),
            currencySymbols[User.wallet.currency]) }}</p>
          <p class="text-[10px]">{{ $formatMoney(tradingCentralMax, currencySymbols[User.wallet.currency]) }}</p>
        </div>
      </div>
      <div v-else>
        <p class="text-[12px] mb-[40px] mt-3">{{ $t('trading_central_access_text') }}</p>
        <router-link :to="'/' + Language + '/tools'"
          class="mt-4 px-3 py-0.5 table text-blue rounded-xl bg-white hover:bg-[#2B63E326] border border-blue border-solid text-center text-sm font-medium">{{
            $t('trading_central_access') }}</router-link>
      </div>
    </div>
    <div :class="isPopup ? 'mt-10 sm:mt-0' : ''">
      <img src="../assets/img/trading-central-homepage.svg" class="mb-0 rtl:rotate-180"
        :class="isPopup ? 'w-[280px] min-w-[160px] h-full hidden sm:block' : 'h-[185px] w-[200px] md:w-[240px]'" />
      <img v-if="isPopup" src="../assets/img/trading-central-homepage-mobile.svg"
        class="mb-0 block sm:hidden w-[280px] h-full m-auto" />
      <!-- <div class="grow bg-white rounded-lg shadow-ts1 p-8">
        <p class="text-gray-900 font-display font-bold text-[1.38rem] leading-7" :class="showNewsletterProgressBar ? 'mb-[26px]' : 'mb-[30px]'">
          <span v-html="$t('daily_market_newsletter')"></span>
        </p>
        <a
          v-if="!showNewsletterProgressBar"
          href="#"
          @click="newsletterSubscribe()"
          class="w-28 py-0.5 mb-2 table text-blue rounded-xl bg-white hover:bg-[#2B63E326] border border-blue border-solid text-center text-sm font-medium"
          >{{ $t('subscribe').tTitle() }}</a
        >
        <div v-else>
          <p class="text-gray-900 text-[8px] pb-1">{{ newsletterProgressCurrency }}</p>
          <div class="h-3 w-full bg-blue rounded-xl bg-opacity-25 relative">
            <div
              class="absolute inset-0 rounded-xl text-white text-center font-medium text-[10px] leading-none"
              :class="newsletterProgressPercentage == 100 ? 'bg-green' : 'bg-blue'"
              :style="'width: ' + Math.floor(newsletterProgressPercentage) + '%;'"
            ></div>
          </div>
          <div class="flex flex-wrap justify-between">
            <span class="text-gray-900 text-[10px] pt-0.5">{{ $formatMoney(Math.min(totalDeposits, newsletterMax), currencySymbols[User.wallet.currency]) }}</span>
            <span class="text-gray-900 text-[10px] font-bold pt-0.5">{{ $formatMoney(newsletterMax, currencySymbols[User.wallet.currency]) }}</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import config from '../config'
import links from '../config/links'

export default {
  props: {
    isPopup: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      tradingCentralMax: 5000.0,
      websiteURL: config.URL.website,
      currencySymbols: config.currencies,
      depositsAfterDate: `18/12/2024 12:00 (${this.$t('GMT')})`,
    }
  },
  watch: {},
  computed: {
    ...mapGetters({
      Language: 'language/code',
      TotalDeposited: 'user/totalTCDeposited',
      User: 'user/all',
    }),
    tradingCentralProgressPercentage() {
      return (Math.min(this.TotalDeposited, this.tradingCentralMax) / this.tradingCentralMax) * 100
    },
    tradingCentralURL() {
      return links.getLink('tradingCentralURL', 'en')
    },
  },
  methods: {
    goToFinance() {
      this.$emit('hide')
      return this.$router.push('/' + (this.Language || 'en') + '/finance').catch(() => { })
    },
  },

}
</script>
<style scoped>
.rotate{
  transform: rotateY('180deg');
}
</style>
